import { ChangeDetectorRef, Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatGridListModule } from '@angular/material/grid-list';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-type-selection',
  imports: [RouterLink, MatCardModule, MatGridListModule],
  templateUrl: './type-selection.html',
  styleUrls: ['./type-selection.scss'],
})
export class TypeSelection {
  cols = 2;

  constructor(private cdr: ChangeDetectorRef) {
    this.updateGridCols();
    window.addEventListener('resize', () => this.updateGridCols());
  }

  updateGridCols() {
    const width = window.innerWidth;
    if (width < 700 && this.cols != 1) {
      this.cols = 1;
      this.cdr.markForCheck();
    } else if (width > 700 && this.cols == 1) {
      this.cols = 2;
      this.cdr.markForCheck();
    }
  }
}
